function complainsDnD() {
    if (document.querySelector('.Complains')) {
        let parElem = document.querySelector('.Complains')
        let inpFile = parElem.querySelector('[type="file"]')

        const preview_list = parElem.querySelector('.Complains__list')

        let fileList = []

        let inpWrap = parElem.querySelector('.Complains__list')
        let img = parElem.querySelectorAll('.item-img')
        
        inpFile.onchange = onChange

        function onChange() {
            // Аннулирование содержимого preview_list
            preview_list.innerHTML = '';

            // По каждому файлу <input>
            [...inpFile.files].forEach(file => {
                // Создаём читателя
                const reader = new FileReader;
                // Вешаем событие на читателя
                reader.addEventListener('loadend', () => {
                    // Элемент списка .preview
                    const item = document.createElement('li');
                    // Картинка для предпросмотра
                    const image = new Image;
                    // URI картинки
                    image.src = `data:${file.type};base64,${btoa(reader.result)}`;
                    // Ссылка на исключение картинки из списка выгрузки
                    const remove = document.createElement('a');
                    remove.innerHTML = '⊗';
                    // Элемент массива fileList
                    const fileItem = {
                        name: file.name,
                        modified: file.lastModified,
                        size: file.size,
                        data: reader.result
                    };
                    // Добавляем элемент в список выгрузки
                    fileList.push(fileItem);
                    // Обработчик клика по ссылке исключения картинки
                    remove.addEventListener('click', () => {
                        // Исключаем элемент с картинкой из списка выгрузки
                        fileList.splice(fileList.indexOf(fileItem), 1);
                        // Удаляем элемент списка (<li>) из <ul> 
                        item.classList.add('removing');
                        setTimeout(() => item.remove(), 100);
                        if (inpWrap.querySelectorAll('.Complains__list-item').length <= 1) {
                            inpFile.value = '';
                        } else {
                        }
                    });
                    item.appendChild(remove);
                    item.appendChild(image);
                    inpWrap.appendChild(item);
                    item.classList.add('Complains__list-item')
                    image.classList.add('item-img')
                });
                // Запускаем чтение файла
                reader.readAsBinaryString(file);
            });
            // Сбрасываем значение <input>
            // Создаем клон <input>
            // const newInput = inpFile.cloneNode(true);
            // Заменяем <input> клоном
            // inpFile.replaceWith(newInput);
            // Теперь input будет указывать на клона
            // input = newInput;
            // Повесим функцию onChange на событие change у нового <input>
            // inpFile.addEventListener('change', onChange);
        }
    }
}